module.exports = __webpack_public_path__ + "img/bannerBlue.dfe03d90.jpg";